module.exports = __webpack_public_path__ + "img/geofenceExit.6945c277.svg";